import * as React from 'react';

import { CartServiceProps } from '../../types';
import { ServiceSummary } from '../../../features/service-summary';

const RefundableTicket: React.FC<CartServiceProps> = ({ onServiceDelete }) => {
	return (
		<ServiceSummary serviceType="RefundableTicket" onDelete={onServiceDelete}>
			{content => <>{content}</>}
		</ServiceSummary>
	);
};

export default RefundableTicket;
